import React from "react";
import { motion } from "framer-motion";

const headerVariants = {
  hidden: { opacity: 0, y: -30 },
  visible: { opacity: 1, y: 0 },
};

const ProjectsHeader: React.FC = () => (
  <motion.section
    className="relative global-container z-5 text-center flex flex-col items-center mb-[8.55rem]"
    variants={headerVariants}
    initial="hidden"
    animate="visible"
    transition={{ duration: 0.8, ease: "easeOut" }}
  >
    <h1 className="h3 text-white mb-[1.2rem]">Our Developments</h1>
    <p className="text-white max-w-[81rem] w-full">
      Explore Dancap Group’s signature developments — where luxury residences
      meet forward-thinking commercial spaces, all designed with quality,
      functionality, and lasting impact in mind. From thoughtfully restored
      heritage buildings to cutting-edge new builds, each project reflects our
      commitment to excellence.
    </p>
  </motion.section>
);

export default ProjectsHeader;
